import { produce } from "immer";
import { createSelector } from "reselect";


const initialState = {
    jobs: null,
    measurements: null
};

const reducer = (state = initialState, action) => produce(state, draft => {
    switch (action.type) {
        case "SET_MEASUREMENTS":
            draft.measurements = action.payload.measurements;
            break;
    }
    return draft;
});

export default reducer;

export const setMeasurements = (measurements) => ({ type: "SET_MEASUREMENTS", payload: { measurements } });

const selectState = (state) => state.sampling;

export const selectMeasurements = createSelector(selectState, (state) => state.measurements);
